import {
  BaseListResponse, KajikiRequestFactory
} from './core'

// GET 統合ログインの認証情報のデータを取得するリクエスト際の時に必要な情報
export interface GetLoginAuthenticationRequest {
  siteId: number
}

export interface GetLoginAuthenticationItemResponse {
  userName: string
  accountName: string
  sso: SsoItem

}

// ssoGroupId：string
// ssoGroupId サポートサイトのカテゴリグループ。
// 本エンドポイントを利用する側で指定させるため、常にnull
// ssoExpiredの有効期限は3日
export interface SsoItem {
  ssoAuthKey: string
  ssoMail: string
  ssoExpired: string
  ssoName: string
  ssoGroupId: null
  ssoChk: string
}

/**
 * 統合ログインの認証情報のエンドポイント
 */
export interface ILoginAuthentication {
  /**
   * 統合ログインの認証情報を取得する
   */
  getLoginAuthentication: (request: GetLoginAuthenticationRequest) => Promise<GetLoginAuthenticationItemResponse>
}

export default class LoginAuthentication implements ILoginAuthentication {
  /**
   * 統合ログインの認証情報を取得する
   */
  getLoginAuthentication(request: GetLoginAuthenticationRequest): Promise<GetLoginAuthenticationItemResponse> {
    const path = `/account`
    return KajikiRequestFactory.getRequest().execute<GetLoginAuthenticationItemResponse>(path)
      .then(response => response.data)
  }
}
